import { render, staticRenderFns } from "./NoticeLightBox.vue?vue&type=template&id=d580bc1c&"
import script from "./NoticeLightBox.vue?vue&type=script&lang=js&"
export * from "./NoticeLightBox.vue?vue&type=script&lang=js&"
import style0 from "./NoticeLightBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports